import { autoinject, PLATFORM } from 'aurelia-framework';
import './pen-offer-view.scss';
import { Tab } from 'elements/tabs/MnTabs';
import { I18N } from 'aurelia-i18n';
import { AsyncErrorHandler } from 'lib/ui';
import { PenOfferService } from 'services/pen/pen-offer-service';
import { PenOfferDto } from 'models/pen/PenOffers';
import { PenOfferStatusService } from 'services/pen/pen-offer-status-service';
import { PenOfferStatusDto } from 'models/pen/PenOfferStatus';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { PubSub } from 'lib/event/PubSub';
import { ToastService } from 'services/toast-service';
import { Router } from 'aurelia-router';
import saveAs from 'file-saver';
import { PenService } from 'services/pen/pen-service';

@autoinject
export class PensOfferView {
  protected penOfferId: number;
  protected penOffer: PenOfferDto;
  protected penId: number;
  protected trimmedComment: string;

  protected penOfferStatuses: PenOfferStatusDto[];

  protected tabsReady = false;
  protected tabs: Tab[] = [
    {
      name: 'dimension',
      title: this.t.tr('notlogg.DesignAndDimensions'),
      view: PLATFORM.moduleName('views/pens/pens-offers/dimension/tab'),
      data: {},
    },
    {
      name: 'specifications',
      title: this.t.tr('general.specifications'),
      view: PLATFORM.moduleName('views/pens/pens-offers/specification/tab'),
      data: {},
    },
    {
      name: 'scope-of-work',
      title: this.t.tr('pens.scopeOfWork'),
      view: PLATFORM.moduleName('views/pens/pens-offers/scope-of-work/tab'),
      data: {},
    },
    // {
    //   name: 'extra-equipment',
    //   title: this.t.tr('general.extraEquipment'),
    //   view: PLATFORM.moduleName('views/pens/pens-offers/extra-equipment/tab'),
    //   data: {},
    // },
    // {
    //   name: 'analysis',
    //   title: this.t.tr('notlogg.analysis'),
    //   view: PLATFORM.moduleName('views/pens/pens-offers/analysis/tab'),
    //   data: {},
    // },
    // {
    //   name: 'rope',
    //   title: this.t.tr('notlogg.rope'),
    //   view: PLATFORM.moduleName('views/pens/pens-offers/rope/tab'),
    //   data: {},
    // },
    // {
    //   name: 'marking-and-customizations',
    //   title: this.t.tr('notlogg.MarkingAndCustomizations'),
    //   view: PLATFORM.moduleName('views/pens/pens-offers/marking/tab'),
    //   data: {},
    // },
    // {
    //   name: 'pricing-and-drawing',
    //   title: this.t.tr('general.pricingAndDrawing'),
    //   view: PLATFORM.moduleName('views/pens/pens-offers/pricing/tab'),
    //   data: {},
    // },
  ];

  constructor(
    private t: I18N,
    private penOfferService: PenOfferService,
    private penOfferStatusService: PenOfferStatusService,
    private confirmation: ConfirmDialog,
    private pubSub: PubSub,
    private router: Router,
    private toastService: ToastService,
    private penService: PenService
  ) {
    pubSub.sub('entity:updated', this.getOffer.bind(this));
  }

  async attached() {
    await this.getOffer();
    await this.getStatuses();
  }

  activate(params: { penOfferId: number; penId: number }) {
    this.penOfferId = params.penOfferId;
    this.penId = params.penId;
  }

  async generateJSON() {
    const blob = await this.penService.generateJSON(this.penId);
    saveAs(blob.blob, blob.fileName);
  }

  @AsyncErrorHandler
  async getOffer() {
    this.tabsReady = false;
    const { data } = await this.penOfferService.getOffer(this.penOfferId);

    this.penOffer = data;

    const commentLength = this.penOffer.Comment?.length;
    if (commentLength > 135) {
      this.trimmedComment = this.penOffer.Comment.slice(0, 135) + '...';
    }

    for (const tab of this.tabs) {
      if (!tab.data) tab.data = {};
      tab.data = {
        penOfferId: this.penOfferId,
        penOffer: this.penOffer,
        penOfferScopeId: this.penOffer.PenOfferScopeId,
        penId: this.penId,
      };
    }

    this.tabsReady = true;
  }

  @AsyncErrorHandler
  async getStatuses() {
    this.penOfferStatuses = await this.penOfferStatusService.getAll();
  }

  @AsyncErrorHandler
  async changeOfferStatus(penOfferStatus: PenOfferStatusDto) {
    const confirmed = await this.confirmation.confirmYesCancel(
      'general.changeOfferStatus',
      this.t.tr('general.changeOfferStatusConfirmation', { x: this.t.tr(penOfferStatus.NameEn) })
    );
    if (!confirmed) return;
    await this.penOfferService.updateOfferStatus(this.penOfferId, penOfferStatus);

    this.pubSub.publish('entity:updated', null);
  }

  @AsyncErrorHandler
  async createPenOrder() {
    this.pubSub.publish('entity-parent:updated', null);
    this.router.navigate(`pen-offer/${this.penOfferId}/pen/${this.penId}/convert`);
  }
}
